import { fromMapLngLat } from '../dashboard/basemapCoord';
import { MAP_LAYER_PHASE_TEXT, MAP_LAYER_STATUS_TEXT } from './constants';

export function mapLayerStatusText(t) {
  if (!t) return '';
  if (t.status === 'processing' && t.phase && MAP_LAYER_PHASE_TEXT[t.phase]) {
    return MAP_LAYER_PHASE_TEXT[t.phase];
  }
  if (t.status === 'succeeded' && t.phase === 'dry_run') {
    return '图层已就绪（DRY_RUN 无真实瓦片）';
  }
  return MAP_LAYER_STATUS_TEXT[t.status] || t.status;
}

/** 任务行右侧状态短文案 */
export function mapLayerRightStatus(t, uploadingText) {
  if (uploadingText) return uploadingText;
  if (!t) return '';
  if (t.status === 'draft') return '待上传';
  if (t.status === 'queued') return '排队切片';
  if (t.status === 'processing') {
    const phase = t.phase && MAP_LAYER_PHASE_TEXT[t.phase] ? MAP_LAYER_PHASE_TEXT[t.phase] : '';
    return phase ? `切片中 · ${phase}` : '切片进行中';
  }
  if (t.status === 'succeeded') {
    return t.phase === 'dry_run' ? '已就绪（试跑）' : '已就绪';
  }
  if (t.status === 'failed') return '切片失败';
  if (t.status === 'cancelled') return '已取消';
  return MAP_LAYER_STATUS_TEXT[t.status] || t.status || '';
}

export function formatBytes(n) {
  const bytes = Number(n) || 0;
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

/** 解析已发布图层 bounds（数组或对象） */
export function parseMapLayerBounds(bounds) {
  if (!bounds) return null;
  if (Array.isArray(bounds) && bounds.length >= 4) {
    const west = Number(bounds[0]);
    const south = Number(bounds[1]);
    const east = Number(bounds[2]);
    const north = Number(bounds[3]);
    if ([west, south, east, north].every(Number.isFinite) && west < east && south < north) {
      return { west, south, east, north };
    }
  }
  if (typeof bounds === 'object') {
    const west = Number(bounds.west ?? bounds.minLon);
    const south = Number(bounds.south ?? bounds.minLat);
    const east = Number(bounds.east ?? bounds.maxLon);
    const north = Number(bounds.north ?? bounds.maxLat);
    if ([west, south, east, north].every(Number.isFinite) && west < east && south < north) {
      return { west, south, east, north };
    }
  }
  return null;
}

export function bboxIntersects(a, b) {
  return a.west < b.east && a.east > b.west && a.south < b.north && a.north > b.south;
}

/** 地图上是否已叠加指定正射栅格层 */
export function isOrthoRasterOnMap(map, id) {
  if (!map || id == null) return false;
  try {
    return !!map.getLayer(`zhxt-ortho-layer-${id}-raster`);
  } catch (_) {
    return false;
  }
}

export function clickToWgs84(lngLat, map) {
  return fromMapLngLat(lngLat.lng, lngLat.lat, undefined, map) || [lngLat.lng, lngLat.lat];
}

export function themeLabelOf(theme) {
  return theme === 'contour' ? '等高线'
    : theme === 'poi' ? '地标'
      : theme === 'building' ? '建筑'
        : '路网';
}

export function bboxModeForTheme(theme) {
  return theme === 'contour' ? 'map-contour'
    : theme === 'poi' ? 'map-poi'
      : theme === 'building' ? 'map-building'
        : 'map-road';
}

/** 地图图层源文件上传进度条文案 */
export function mapLayerPhaseText(u) {
  if (!u) return '';
  if (u.phase === 'picking') return '请在系统对话框中选择源文件…';
  if (u.phase === 'credentials') return '正在申请 OSS 直传凭证…';
  if (u.phase === 'uploading') return `正在直传 OSS ${u.percent || 0}%（${formatBytes(u.fileSize)}）`;
  if (u.phase === 'registering') return '上传完成，正在登记到任务…';
  if (u.phase === 'done') return `已登记：${u.fileName}（${formatBytes(u.fileSize)}），状态应为「排队切片」`;
  if (u.phase === 'error') return u.error || '上传失败';
  return '';
}
